let currentItemIndex = 0;
let objectId = "";
let dataWithIds = [];
let expandedItems = [];
let isPlus = false;
let addItemLoader = false;
let delteItemLoader = false;
let playedStatusLoader = false;
let replayLoader = false;
const BASE_URL = "https://api-dream-drive.injozitech.com/api";
//const BASE_URL_NEW = "https://api-dream-drive.injozitech.com/api";
// const BASE_URL = "https://e91c-119-155-140-10.ngrok-free.app/api";
let gameData = {};
let customerId = null;
let penTool = false;
let cart_id = null;
let imageDimensions = null;
let toGetDataFromWebSocket = true;
let availableHeight = 0;
let allowHeightChange = true;
let testUserId = null;

document.addEventListener("DOMContentLoaded", async () => {
  const response = await fetch("/cart.js");
    const cart = await response.json();
    // console.log("cart....", cart);
    if (cart.item_count == 0) {
     document.cookie = "cart=; path=/;";
      console.log("abasj");
    }
  await fetchCartItems();
  //   const socket = io("https://e91c-119-155-140-10.ngrok-free.app", {
  //   extraHeaders: {
  //     'ngrok-skip-browser-warning': 'true'
  //   }
  // });

  const socket = io("https://api-dream-drive.injozitech.com");
  socket.on("connect", function () {
    console.log("Connected to the server via Socket.io");
  });

  socket.emit("register", `${cart_id}`, function () {
    console.log("Connected to the server via Socket.io with ID 12345");
  });

  socket.on("disconnect", function () {
    console.log("Disconnected from the server");
  });

  // Listen for updates from the server
  socket.on("attempt_updated", async function (response) {
    console.log("Cart updated:", response);
    if (response?.data?.attempts_array == 0) {
      const modal = document.getElementById("modal");
      modal.style.display = "flex";
    }

    if (toGetDataFromWebSocket) {
      try {
        const dataToShow = await getDataHandleAndImages(
          response?.data?.attempts_array
        );
        dataWithIds = dataToShow;
        displayCartItems(dataToShow);
        sendWebSocketUpdateStatusToIframe();
      } catch (error) {}
    }
  });
});

async function handleCheckout() {
  if (dataWithIds.length==0){
    return false;
  }
  if (dataWithIds.some((item) => !item.playState.played)) {
    const modal = document.getElementById("modal-checkouterror");
    modal.style.display = "flex";
  } else {
    await updateCartPropertiesForCoordinates();
    checkout();
  }
}

async function updateCartPropertiesForCoordinates() {
  try {
    const response = await fetch("/cart.js");
    const cart = await response.json();
    const coordinates = getCartItemsCoordinates();

    for (const cartItem of cart.items) {
      const variantId = cartItem.variant_id.toString();
      const properties = coordinates[variantId] || {};
      try {
        const updateResponse = await fetch("/cart/change.js", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            id: cartItem.key,
            quantity: cartItem.quantity,
            properties: properties,
          }),
        });
        await updateResponse.json();
      } catch (error) {
        console.error(`Error updating cart for variant ${variantId}:`, error);
      }
    }
  } catch (error) {
    console.error("Error retrieving cart data:", error);
  }
}

function getCartItemsCoordinates() {
  const cartItemsCoordinates = {};

  document
    .querySelectorAll("#custom-cart-drawer .cart-item")
    .forEach((cartItem, index) => {
      const varid = cartItem.getAttribute("data-varid");
      const coordinatesDiv = document.querySelector(
        `#coordinates-${index + 1}`
      );

      if (coordinatesDiv) {
        const xCoordinate = coordinatesDiv
          .querySelector(`#x-coordinate-${index + 1}`)
          ?.textContent.replace("X : ", "")
          .trim();
        const yCoordinate = coordinatesDiv
          .querySelector(`#y-coordinate-${index + 1}`)
          ?.textContent.replace("Y : ", "")
          .trim();

        if (xCoordinate && yCoordinate) {
          if (!cartItemsCoordinates[varid]) {
            cartItemsCoordinates[varid] = { X: "", Y: "" };
          }
          cartItemsCoordinates[varid].X += cartItemsCoordinates[varid].X
            ? `, ${xCoordinate}`
            : xCoordinate;
          cartItemsCoordinates[varid].Y += cartItemsCoordinates[varid].Y
            ? `, ${yCoordinate}`
            : yCoordinate;
        } else {
          console.log(
            `Coordinates missing for variant ID ${varid} at index ${index + 1}`
          );
          if (!cartItemsCoordinates[varid]) {
            cartItemsCoordinates[varid] = { X: "", Y: "" };
          }
        }
      }
    });

  console.log("getCartItemsCoordinates", cartItemsCoordinates);
  return cartItemsCoordinates;
}

const isMobile = window.innerWidth < 768;

const handleShowEntries = () => {
  const itemsContainer = document.getElementById("custom-cart-drawer");
  const itemsParent = document.getElementById("drawer-parent");
  const tempImg = document.getElementById("temp-img");
  const iframe = document.getElementById("testframe");

  // Toggle the display style between 'block' and 'none'
  if (
    itemsContainer.style.display === "none" ||
    itemsContainer.style.display === ""
  ) {
    allowHeightChange = true;
    itemsContainer.style.display = "block";
    itemsContainer.style.height = "50%";
    itemsParent.style.height = `${availableHeight - 52}px`;
    itemsParent.style.justifyContent = "flex-start";
    document.getElementById("items-arrow").src = arrowDownUrl;
    tempImg.style.height = "0px";
  } else {
    allowHeightChange = false;
    itemsContainer.style.display = "none";
    itemsContainer.style.height = "130px";
    // itemsParent.style.height = "20vh";
    itemsParent.style.height = "130px";
    // availableHeight = 0;
    // itemsParent.style.justifyContent = "flex-end";
    document.getElementById("items-arrow").src = arrowUpUrl;
    tempImg.style.display = "block";
    tempImg.style.height = `${availableHeight / 2 - 110}px`;
    tempImg.style.backgroundColor = "#ccf2cc";
    // iframe.style.height = `${iframe.offsetHeight-100}px`
  }
};

const getDataHandleAndImages = async (data) => {
  try {
    const _response = await fetch("/cart.js");
    const cart = await _response.json();
    console.log("cart-----11111", cart.items);

    const dataToShow = data.map((item) => {
      if (!item?.handle) {
        const itemWithImageData = cart.items.find(
          (_item) => _item.product_id === item.product_id
        );
        item = {
          ...item,
          handle: itemWithImageData?.vendor || "Car Name",
          image: itemWithImageData?.image || "",
        };
      }
      return item;
    });
    // console.log("dataToShow", dataToShow);
    return dataToShow;
  } catch (error) {
    return error;
  }
};

function loadCustomStylesheet() {
  // Check if the specific element or section exists on the page
  const drawerElement = document.querySelector(".drawer-section");

  // Only load the custom stylesheet if the element exists
  if (drawerElement && !document.getElementById("custom-stylesheet")) {
    const link = document.createElement("link");
    link.id = "custom-stylesheet";
    link.rel = "stylesheet";
    link.href = "{{ 'custom-drawer.css' | asset_url }}"; // Path to your custom stylesheet
    document.head.appendChild(link);
  }
}

loadCustomStylesheet();

function toggleDrawer() {
  const drawer = document.querySelector(".drawer-parent");
  if (drawer.style.display === "none" || drawer.style.display === "") {
    drawer.style.display = "block";
  } else {
    drawer.style.display = "none";
  }
}

function managePlayState(items) {
  // Check if all items have a playState object and are played
  const allItemsPlayed = items.every((item) => item.playState?.played);
  if (allItemsPlayed) {
    return items; // Do nothing if all items are played
  }

  // Check if there is an item with inPlay set to true
  const hasInPlayItem = items.some((item) => item.playState?.inPlay);

  // If no item is in play, find the first item with toPlay set to true
  if (!hasInPlayItem) {
    const firstToPlayIndex = items.findIndex((item) => item.playState?.toPlay);

    // Update the first item with toPlay: true to inPlay: true
    if (firstToPlayIndex !== -1) {
      items[firstToPlayIndex] = {
        ...items[firstToPlayIndex],
        playState: {
          inPlay: true,
          toPlay: false,
          played: false,
        },
      };
    }
  }

  // Check if every item has a playState property
  const noItemHasPlayState = items.every((item) => !item.playState);

  if (noItemHasPlayState) {
    items = items.map((item, i) => {
      if (i == 0) {
        item = {
          ...item,
          playState: {
            inPlay: true,
            toPlay: false,
            played: false,
          },
        };
      } else {
        item = {
          ...item,
          playState: {
            inPlay: false,
            toPlay: true,
            played: false,
          },
        };
      }
      return item; // Return the modified item
    });
  }

  return items;
}

const getGameByProductId = async (productId, customerID) => {
  const url = `${BASE_URL}/game/getGame`;

  try {
    const response = await fetch(url, {
      //     headers: {
      //    'ngrok-skip-browser-warning': 'true'
      // },
      method: "GET",
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const response1 = await response.json();
    const { _id } = response1.data;

    gameData = {
      game_id: _id,
      user_id: customerID,
      order_no: "qweyrui",
      player_type: "User",
    };
  } catch (error) {
    console.error("There was a problem with the fetch operation:", error);
    const modal1 = document.getElementById("modal-gameerror");
    modal1.style.display = "flex";
  }
};

const sendCartDataToGetIds = async (data, cart_id) => {
  gameData = { ...gameData, attempts_array: data, cart_id: cart_id };
  try {
  
    const response = await fetch(`${BASE_URL}/game/createGameAttempt`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(gameData),
    });


    if (!response.ok) {
      throw new Error(`Error: ${response.statusText}`);
    }

    const result = await response.json();
    objectId = result.data._id;
    localStorage.setItem("idToGetGameData", result.data._id);
    idToGetMarkers(objectId);
    return result;
  } catch (error) {
    console.error("Error:", error);
    return error;
  }
};

const addCartItem = async (index) => {
  console.log("index", index, expandedItems);
  try {
    // Check if any item in expandedItems has inPlay: true
    const isInPlayTrue = dataWithIds.some(
      (item) => item.playState && item.playState.inPlay
    );

    // Set playState for the item to be added based on whether an item with inPlay: true exists
    const playState = isInPlayTrue
      ? { toPlay: true, inPlay: false, played: false }
      : { toPlay: true, inPlay: true, played: false }; // If no item has inPlay: true, set inPlay to true

     

    const response = await fetch(`${BASE_URL}/game/addNewAttemptItem`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        // 'ngrok-skip-browser-warning': 'true'
      },
      body: JSON.stringify({
        _id: objectId,
        item_obj: {
          ...expandedItems[index],
          playState: playState,
        },
        index: index,
      }),
    });

    if (!response.ok) {
      throw new Error(`Error: ${response.statusText}`);
    }

    const result = await response.json();
    return result;
  } catch (error) {
    console.error("Error:", error);
    return error;
  }
};

const deleteCartItem = async (index) => {
  try {
    
    const response = await fetch(`${BASE_URL}/game/deleteAttemptItem`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        _id: objectId,
        item_id: dataWithIds[index].item_id,
        quantity: dataWithIds[index].quantity - 1,
        product_id: dataWithIds[index].product_id,
      }),
    });

    if (!response.ok) {
      throw new Error(`Error: ${response.statusText}`);
    }

    const result = await response.json();
    return result;
  } catch (error) {
    console.error("Error:", error);
    return error;
  }
};

const addAttemptData = async (
  index,
  playState,
  coordinates,
  image_coordinates
) => {
  try {
    
    const response = await fetch(`${BASE_URL}/game/updateGameAttempt`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        _id: objectId,
        item_id: dataWithIds[index].item_id,
        coordinates: coordinates,
        image_coordinates: image_coordinates,
        playState: playState,
      }),
    });

    if (!response.ok) {
      throw new Error(`Error: ${response.statusText}`);
    }

    const result = await response.json();
    return result;
  } catch (error) {
    console.error("Error:", error);
    return error;
  }
};

function generateRandomId(length = 8) {
  const characters =
    "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
  let result = "";
  const charactersLength = characters.length;

  for (let i = 0; i < length; i++) {
    result += characters.charAt(Math.floor(Math.random() * charactersLength));
  }

  return result;
}

function setPenToolinIframe(state) {
  // console.log("in item add to iframe");
  const gameIframe = document.getElementById("testframe");

  const data = { penTool: state };
  gameIframe.contentWindow.postMessage(data, "*");
}

function placeItemInIframe(index) {
  // console.log("in item add to iframe", dataWithIds[index].playState);
  if (dataWithIds[index]?.playState?.inPlay) {
    const gameIframe = document.getElementById("testframe");
    const data = {
      addAttempt: true,
      id: objectId,
      item_id: dataWithIds[index].item_id,
    };
    gameIframe.contentWindow.postMessage(data, "*");
  }
}
function sendWebSocketUpdateStatusToIframe() {
  const gameIframe = document.getElementById("testframe");
  const data = { cartUpdated: true, id: objectId };
  gameIframe.contentWindow.postMessage(data, "*");
}

function sendMessageToIframe(index) {
  const gameIframe = document.getElementById("testframe");
  const data = { index: index };
  gameIframe.contentWindow.postMessage(data, "*");
}

function sendAddCartItemStatusToIframe() {
  const gameIframe = document.getElementById("testframe");
  const data = { addItemLoader: addItemLoader };
  gameIframe.contentWindow.postMessage(data, "*");
}

function sendPlayedStatusToIframe() {
  const gameIframe = document.getElementById("testframe");
  const data = { playedStatusLoader: playedStatusLoader };
  gameIframe.contentWindow.postMessage(data, "*");
}

function deleteCoordinatesInIframe(index) {
  const gameIframe = document.getElementById("testframe");
  const data = { deletedMarker: dataWithIds[index].item_id, _id: objectId };
  gameIframe.contentWindow.postMessage(data, "*");
}

function idToGetMarkers(id) {
  const gameIframe = document.getElementById("testframe");
  const data = { idForMarkers: id };
  gameIframe.contentWindow.postMessage(data, "*");
}

async function replaySpecificTicket(index) {
  if (!replayLoader) {
    const statusImage = document.getElementById(`status-image-${index}`);
    const imgChild = statusImage.querySelector("img");
    try {
      replayLoader = true;
      imgChild.src = loader;
      let tempIndexOfInplay = dataWithIds.findIndex(
        (item) => item?.playState?.inPlay === true
      );

      if (tempIndexOfInplay != -1) {
        const result = await addAttemptData(tempIndexOfInplay, {
          toPlay: true,
          inPlay: false,
          played: false,
        });
        dataWithIds = result.data.attempts_array;
      }

      const result = await addAttemptData(
        index,
        {
          toPlay: false,
          inPlay: true,
          played: false,
        },
        (coordinates = null)
      );
      dataWithIds = result?.data?.attempts_array;
      const gameIframe = document.getElementById("testframe");
      const data = {
        replayId: dataWithIds[index]?.item_id,
        replayIndex: index,
        _id: objectId,
      };
      gameIframe.contentWindow.postMessage(data, "*");
      displayCartItems(dataWithIds);
      replayLoader = false;
    } catch (error) {
      replayLoader = false;
    }
  }
}

const reload = `
  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="size-6">
    <path stroke-linecap="round" stroke-linejoin="round" d="M16.023 9.348h4.992v-.001M2.985 19.644v-4.992m0 0h4.992m-4.993 0 3.181 3.183a8.25 8.25 0 0 0 13.803-3.7M4.031 9.865a8.25 8.25 0 0 1 13.803-3.7l3.181 3.182m0-4.991v4.99" />
  </svg>
`;

function getPlayStateIcon(playState) {
  if (playState?.inPlay) {
    return `<img src="${inPlayIcon}" class="status-icon" />`;
  } else if (playState?.played) {
    return `<img src="${reloadIcon}" class="status-icon" />`;
  } else {
    return `<img src="${toPlayIcon}" class="status-icon" />`;
  }
}

const scrollToInplay = (dataWithIds) => {
  const inPlayItem = dataWithIds.findIndex((item) => item.playState.inPlay);
  const inPlayCard = document.getElementById(`CartItem-${inPlayItem + 1}`);
  inPlayCard?.scrollIntoView({
    behavior: "smooth",
    block: "nearest",
    inline: "nearest",
  });
};

// Async function to fetch cart items from the server
async function fetchCartItems() {
  try {
    const response = await fetch("/cart.js");
    const cart = await response.json();
    // console.log("cart....", cart);
    if (cart.item_count == 0) {
      const modal = document.getElementById("modal");
      modal.style.display = "flex";
    }
    expandedItems = expandCartItems(cart.items);
    var customerInfo = document.getElementById("customer-info");
    var customerID = customerInfo ? customerInfo.dataset.customerId : null;
    testUserId = customerID;
    const gameUrl = await getGameByProductId(
      cart.items[0]?.product_id,
      customerID
    );
    cart_id = cart?.token?.split("?")[0];

    const result = await sendCartDataToGetIds(
      expandedItems,
      cart?.token?.split("?")[0]
    );
    dataWithIds = result.data.attempts_array;
    await displayCartItems(dataWithIds);
    scrollToInplay(dataWithIds);
  } catch (error) {
    // Log any errors that occur during the fetch
    console.error("Error fetching cart items:", error);
  }
}

//Function to expand cart items based on their quantities
function expandCartItems(items) {
  let expanded = [];
  let count = 0;
  items.forEach((item, index) => {
    for (let i = 0; i < item.quantity; i++) {
      expanded.push({
        ...item,
        unique_id: generateRandomId(),
        line: index + 1,
        quantity: item.quantity,
        playState:
          count == 0
            ? {
                inPlay: true,
                toPlay: false,
                played: false,
              }
            : {
                inPlay: false,
                toPlay: true,
                played: false,
              },
      });
      count = 1;
    }
  });
  return expanded;
}

const handleSetPlay = async (index) => {
  if (!dataWithIds[index].playState.played) {
    const inPlayTicket = dataWithIds.findIndex(
      (item) => item?.playState?.inPlay === true
    );

    try {
      await addAttemptData(inPlayTicket, {
        toPlay: true,
        inPlay: false,
        played: false,
      });

      const result = await addAttemptData(index, {
        toPlay: false,
        inPlay: true,
        played: false,
      });

      dataWithIds = result?.data?.attempts_array;
      displayCartItems(dataWithIds);
    } catch (error) {
      console.error(error); // Add error handling
    }
  }
};

async function displayCartItems(cartItems) {
  cartItems = managePlayState(cartItems);
  cartItems = await getDataHandleAndImages(cartItems);
  console.log(".....cartItems", cartItems);

  // Get the container element where cart items will be displayed
  const cartItemsContainer = document.getElementById("cart-items-container");

  // Clear any previous cart items
  cartItemsContainer.innerHTML = "";

  // Iterate over each item in the cart
  cartItems?.forEach((item, index) => {
    // Create a new div element for the cart item
    let metaImage = window.productsImages[item.product_id];
    const itemElement = document.createElement("div");

    // Assign a class name to the cart item element
    itemElement.className = "cart-item";
    itemElement.dataset.varid = `${item.variant_id}`;
    // Assign a unique ID to the cart item element based on its index
    itemElement.id = `CartItem-${index + 1}`;

    itemElement.style.maxWidth = isMobile ? "100%" : "100%";
    itemElement.style.marginBottom = isMobile && "0px";
    itemElement.style.borderBottom = !isMobile && "1px solid black";
    itemElement.style.padding = "2px 12px";
    itemElement.style.color = "black";
    itemElement.style.backgroundColor = "white";
    itemElement.style.padding = isMobile && "0px";
    itemElement.style.border = item?.playState?.inPlay && "3px solid #05FF00";
    itemElement.style.borderTop =
      isMobile && item?.playState?.inPlay && "2px solid #05FF00";
    itemElement.style.borderBottom =
      isMobile && item?.playState?.inPlay && "2px solid #05FF00";
    itemElement.style.borderBottom =
      isMobile && !item?.playState?.inPlay && "1px solid #d2d3d1";
    itemElement.style.borderBottom =
      !item?.playState?.inPlay && !isMobile && "3px solid #f5f5f7";

    if (item?.playState?.inPlay) {
      currentItemIndex = index;
    }
    // Set the inner HTML of the cart item element with item details
    if (isMobile) {
      // console.log("item play state", item.playState);
      if (item?.playState?.played) {
        itemElement.innerHTML = `
  <div class="product-data" style="padding:10px 0px;" >
    <div class="product-data-items" style="display: flex; justify-content: space-between ; align-items:center; margin:0px;">
      <div class="icon" style="width:20%" onclick="updateCartItem(${
        item.quantity - 1
      }, ${item.variant_id}, ${index}, false)">
        <div class="play-state-mbl" style="display: flex; justify-content: center; align-items: center; border-radius: 50%; padding: 2px; margin:0px 7px 0px 10px">
            <img id="delete-image-${index}" src="${mobileDelete}" class="status-icon" />            
        </div>
      </div>
      <div  style="display:flex; flex-direction:column; width:30%; white-space: nowrap; overflow: hidden; text-overflow: ellipsis; padding-right:10px;">
        <h3 class="car-name" style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis; max-width : 100px; margin:0px;">${
          item?.title
        }</h3>
        <div class="car-name-mbl" style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis;">${
          item.vendor
        } </div>
      </div>
      <div class="car-image">
        <img src="${metaImage}" alt="${item.title}" width="100%">
      </div>
      <p class="car-number" style="text-align: center">${index + 1} of ${
          cartItems.length
        }</p>
              
    </div>
      <div class="coordinates-div-paren" style="display: flex; color:#04C000; font-size:10px;">
        ${
          item?.coordinates
            ? `
          <div style="font-weight : 700;" class="coordinates-di" id="coordinates-${
            index + 1
          }" style="display: flex; flex-direction:column; color:"#04C000"">
            <div id="x-coordinate-${
              index + 1
            }" style="margin-right: 10px;">X : ${
                item?.image_coordinates?.[0] || item.coordinates[0]
              }</div>
            <div id="y-coordinate-${index + 1}">Y : ${
                item?.image_coordinates?.[1] || item.coordinates[1]
              }</div>
          </div>`
            : `
          <div id="coordinates-${
            index + 1
          }" style="display: flex; justify-content: space-between; align-items: center"></div>`
        }
      </div>  
    <div style="display: flex ; align-items:center; margin-right : 5px " >
          <div class="icon" onclick="updateCartItem(${item.quantity + 1}, ${
          item.variant_id
        }, ${index}, ${true})">

             <img id="add-image-${index}" src="${addItemIcon}" style="width:25px ; height:25px; margin-right : 5px;" />            
          </div>
          <div id="status-image-${index}" onClick="replaySpecificTicket(${index})" class="icon play-state-icon">
              <img src="${mobileReload}" style="width:25px ; height:25px ; margin-right:5px;" />            
          </div>
        </div>
  </div>
   
`;
      } else {
        itemElement.innerHTML = `
  <div class="product-data" style="${
    item.playState.inPlay && "background-color:#e6ffe5"
  }" onclick="()=>handleSetPlay(${index})">
    <div class="product-data-items" style="display: flex; justify-content: space-between; align-items:center;">
      <div class="icon" style="width:20%" onclick="updateCartItem(${
        item.quantity - 1
      }, ${item.variant_id}, ${index}, false)">
        <div class="play-state-mbl" style="display: flex; justify-content: center; align-items: center; border-radius: 50%; padding: 2px; margin:0px 7px 0px 10px;">
           <img id="delete-image-${index}" src="${mobileDelete}" class="status-icon" />            
        </div>
      </div>
     <div  style="display:flex; flex-direction:column; width:30% ; white-space: nowrap; overflow: hidden; text-overflow: ellipsis;  padding-right:10px;">
        <h3 class="car-name" style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis; max-width : 100px; margin:0px;">${
          item?.title
        }</h3>
        <div class="car-name-mbl" style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis;">${
          item.vendor
        }  </div>
      </div>
      <div class="car-image">
        <img src="${metaImage}" alt="${item.title}" width="100%">
      </div>
      <p class="car-number" style="text-align: center">${index + 1} of ${
          cartItems.length
        }</p>
     
    </div>
     <p onClick="placeItemInIframe(${index})" class="play-state-text" style="background-color: ${
          item?.playState?.inPlay && "#01ff00"
        }; color: ${
          item?.playState?.inPlay ? "#444444" : "#1877F2"
        } ; margin-right : ${item?.playState?.toPlay && "15px"}">
        ${
          item?.playState?.inPlay
            ? `PLACE <img src="${placeIcon}"/>`
            : item?.playState?.toPlay
            ? "TO PLAY"
            : item?.playState?.played
            ? "Replay"
            : ""
        }
      </p>
    <div class="coordinates-div-parent" style="display: flex; justify-content: space-between; margin-top: 10px; margin-bottom: 10px;  gap : 5px">
      ${
        item?.coordinates
          ? `
        <div class="coordinates-div" id="coordinates-${
          index + 1
        }" style="display: flex; justify-content: space-between; align-items: center ;">
          <div id="x-coordinate-${index + 1}" style="margin-right: 10px;">X : ${
              item?.image_coordinates?.[0] || item.coordinates[0]
            }</div>
          <div id="y-coordinate-${index + 1}">Y : ${
              item?.image_coordinates?.[1] || item.coordinates[1]
            }</div>
        </div>`
          : `
        <div id="coordinates-${
          index + 1
        }" style="display: flex; justify-content: space-between; align-items: center"></div>`
      }
    </div>
  </div>
`;
      }
    } else {
      itemElement.innerHTML = `
        <div class="product-data" onclick="handleSetPlay(${index})">
          <div style="display : flex; justify-content : space-between">
            <div style="display:flex; align-items:center">
        <h3 class="car-name" style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis;  margin-right:5px;">
        ${item?.title || ""}
        </h3>
        <div style="font-size:14px;">${item.vendor}</div>
      </div>
            <p class="car-number" style="text-align : left">${index + 1} of ${
        cartItems.length
      }</p> 
          </div>
          <div style="display : flex; justify-content : space-between ; ">
            <div class="car-image">
              <img src="${metaImage}" alt="${item.title}" width="100%">
            </div>
            ${
              item?.coordinates
                ? `
              <div class="coordinates-div" id="coordinates-${
                index + 1
              }" style="display:flex; justify-content: space-between; align-items: center">
                <div id="x-coordinate-${
                  index + 1
                }" style="marginRight : "10px";>X : ${
                    item?.image_coordinates?.[0] || item.coordinates[0]
                  }</div>
                <div id="y-coordinate-${index + 1}">Y : ${
                    item?.image_coordinates?.[1] || item.coordinates[1]
                  }</div>
              </div>`
                : ` 
              <div id="coordinates-${
                index + 1
              }" class="coordinates-div" style="display:flex; justify-content: space-between; align-items: center"></div>`
            }
          </div>
        </div>
        <div class="item-controls">
          <div onClick="replaySpecificTicket(${index})" class="icon play-state-icon">
            <div id="status-image-${index}" class="play-state" style=" border-radius: 50%; display: flex; justify-content: center; align-items: center;">
              ${getPlayStateIcon(item.playState)}
            </div>
            <p class="play-state-text">
              ${
                item?.playState?.inPlay
                  ? "In Play"
                  : item?.playState?.toPlay
                  ? "To Play"
                  : item?.playState?.played
                  ? "Replay"
                  : ""
              }
            </p>
          </div>
          <div class="icon" onclick="updateCartItem(${item.quantity - 1}, ${
        item.variant_id
      }, ${index}, ${false})">
            <div class="play-state" style="display: flex; justify-content: center; align-items: center;  border-radius: 50%;">
              <img id="delete-image-${index}" src="${deleteIcon}" class="status-icon" />            
            </div>
            <p class="play-state-text">Delete</p>
          </div>
          <div class="icon" id="button-{${generateRandomId()}}" onclick="updateCartItem(${
        item.quantity + 1
      }, ${item.variant_id}, ${index}, ${true})">
             <div class="play-state" style="display: flex; justify-content: center; align-items: center;  border-radius: 50%;">
              <img id="add-image-${index}" src="${addItemIcon}" class="status-icon" />            
            </div>
            <p class="play-state-text">Add</p>
          </div>
        </div>
      `;
    }

    // Append the cart item element to the container
    cartItemsContainer.appendChild(itemElement);
  });

  // Get the element to display the total price
  const totalPriceElement = document.getElementById("cart-total-price");

  // Set the text content of the total price element
  // totalPriceElement.textContent = `Total: ${Shopify.formatMoney(cart.total_price, window.money_format)}`;
}

// Function to update the play state display
function updatePlayStateDisplay(
  itemElement,
  playState,
  parentElement,
  prevElement
) {
  if (parentElement && prevElement) {
    parentElement.style.border = "1px solid #05FF00";
    prevElement.style.border = "none";
  }

  const changeBg = itemElement.children[0];
  const changeText = itemElement.children[1];

  const svgContentInPlay = `
    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="#ffffff" class="size-6">
      <path stroke-linecap="round" stroke-linejoin="round" d="m4.5 12.75 6 6 9-13.5" />
    </svg>
  `;

  const svgContentReload = `
    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="size-6">
      <path stroke-linecap="round" stroke-linejoin="round" d="M16.023 9.348h4.992v-.001M2.985 19.644v-4.992m0 0h4.992m-4.993 0 3.181 3.183a8.25 8.25 0 0 0 13.803-3.7M4.031 9.865a8.25 8.25 0 0 1 13.803-3.7l3.181 3.182m0-4.991v4.99" />
    </svg>
  `;

  if (playState.toPlay) {
    changeText.textContent = "Not Played";
  } else if (playState.inPlay) {
    changeText.textContent = "In Play";
    changeBg.style.backgroundColor = "grey";
    changeBg.innerHTML = svgContentInPlay; // Set SVG content for "in play"
  } else if (playState.played) {
    changeText.textContent = "Replay";
    changeBg.innerHTML = svgContentReload; // Set SVG content for "played"
    changeBg.style.backgroundColor = "#05FF00";
  } else {
    changeText.textContent = "Not in Play"; // Default text if no state matches
    changeBg.innerHTML = ""; // Clear SVG content
  }
}

const getLineToDeleteItem = (itemIndex) => {
  const uniqueIds = dataWithIds.filter(
    (item, index, self) =>
      index === self.findIndex((t) => t.product_id === item.product_id)
  );
  let line = null;
  if (itemIndex >= dataWithIds.length) {
    line = uniqueIds.findIndex(
      (item) =>
        item.product_id == dataWithIds[dataWithIds.length - 1].product_id
    );
  } else {
    line = uniqueIds.findIndex(
      (item) => item.product_id == dataWithIds[itemIndex].product_id
    );
  }
  return line + 1;
};

// Async function to update the quantity of a cart item
async function updateCartItem(quantity, variantId, index, plus) {
  const result = dataWithIds.reduce((acc, item) => {
    if (!acc[item.id]) {
      acc[item.id] = item.quantity;
    }
    return acc;
  }, {});

  if (index < dataWithIds.length) {
    const idToUpdate = dataWithIds[index].id;
    if (result[idToUpdate] !== undefined) {
      result[idToUpdate] = quantity; // Update with the new quantity
    }
  } else {
    const idToUpdate = dataWithIds[index - 1].id;
    if (result[idToUpdate] !== undefined) {
      result[idToUpdate] = quantity; // Update with the new quantity
    }
  }

  console.log(result);

  try {
    const line = getLineToDeleteItem(index);
    const body = JSON.stringify({
      updates: result,
      sections: ["cart-items", "cart-icon-bubble"],
      sections_url: window.location.pathname,
      note: testUserId,
    });
    console.log("body------->>>", body);

    if (plus) {
      // addItemLoader = true;
      // sendAddCartItemStatusToIframe();
      const addImage =
        index < dataWithIds.length
          ? document.getElementById(`add-image-${index}`)
          : document.getElementById(`add-image-${index - 1}`);

      try {
        addImage.src = loader;
        const response = await fetch("/cart/update.js", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body,
        });

        if (!response.ok) {
          throw new Error("Failed to update cart on the server");
        }

        const cart = await response.json();

        cart?.items?.forEach((item) => {
          const element = document.querySelector(
            `[data-quantity-variant-id="${item.id}"]`
          );
          if (element) {
            element.value = item.quantity;
          }
        });

        expandedItems = expandCartItems(cart.items);

        try {
          // alert("sending request");
          const updatedData = await addCartItem(index);
        displayCartItems(updatedData.data.attempts_array);
          dataWithIds = updatedData.data.attempts_array;
          const cartIcon = document.querySelector(".cart-count-bubble");
          cartIcon.children[0].textContent = dataWithIds.length;
          addImage.src = addItemIcon;
        } catch (itemError) {
          console.error("Error adding cart item:", itemError);
          addImage.src = addItemIcon;

          // addItemLoader = false;
          // sendAddCartItemStatusToIframe();
        }
      } catch (fetchError) {
        addImage.src = addItemIcon;

        console.error("Error in fetch operation:", fetchError);
      } finally {
        addImage.src = addItemIcon;

        // addItemLoader = false;
        // sendAddCartItemStatusToIframe();
      }
    }

    if (!plus && !delteItemLoader) {
      document.querySelectorAll('.cartremoveitem').forEach(button => {
        button.setAttribute("disabled", "disabled");
      });
      delteItemLoader = true;
      const deleteImage = document.getElementById(`delete-image-${index}`);
      try {
        deleteImage.src = loader;
        const updatedData1 = await deleteCartItem(index);
        console.log("updatedData1"+updatedData1)
        try {
          const response = await fetch("/cart/update.js", {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            body,
          });
          const cart = await response.json();
          displayCartItems(updatedData1?.data?.attempts_array)

          let totalItems = 0;
          cart?.items?.forEach((item) => {
            const element = document.querySelector(
              `[data-quantity-variant-id="${item.id}"]`
            );

            totalItems += item?.quantity;
            if (element) {
              element.value = item.quantity;
            }
          });

          const cartIcon = document.querySelector(".cart-count-bubble");
          cartIcon.children[0].textContent = totalItems;
          expandedItems = expandCartItems(cart.items);
          // console.log("response.....", response);
          if (!response.ok) {
            throw new Error("Failed to update cart on the server");
          }
          else{
            window.location.reload(true);
          }
        } catch (itemError) {
          console.error("Error deleting cart item:", itemError);
        }
      } catch (fetchError) {
        console.error("Error in fetch operation:", fetchError);
      } finally {
        delteItemLoader = false;
      }
    }
  } catch (error) {
    // Handle unexpected errors and ensure loaders are reset
    addItemLoader = false;
    delteItemLoader = false;
    console.error("Unexpected error:", error);
  }
}

// Async function to remove a cart item

// Function to navigate to the checkout page
async function checkout() {
  await updateCartPropertiesForCoordinates();
  // const _response = await fetch("/cart.js");
  // const cart = await _response.json();
  // console.log("updated cart at checkout...", cart);
  // setTimeout(()=>{
  window.location.href = "/checkout";
  // }, 20000)
}

// Counter to keep track of the current item being updated

const getStatusDiv = (index) => {
  const cartItemElement1 = document.getElementById(`CartItem-${index + 1}`);
  const previousCartItemElement1 = document.getElementById(`CartItem-${index}`);
  const cartItemDetails1 = cartItemElement1.children[1];
  const cartItemPrimaryDetail1 = cartItemDetails1.children[0];
  const cartItemSecondaryDetail1 = cartItemPrimaryDetail1?.children[1];
  return { cartItemPrimaryDetail1, cartItemElement1, previousCartItemElement1 };
};

const setNextDivInPlayStatus = (index) => {
  dataWithIds[index].playState = {
    inPlay: true,
    toPlay: false,
    played: false,
  };
};

const setInPlayOfCurrentItem = (newIndexToPlay) => {
  if (isMobile) {
  } else {
  }

  if (dataWithIds[newIndexToPlay].playState.played) {
    dataWithIds[newIndexToPlay].playState = {
      inPlay: false,
      toPlay: false,
      played: true,
    };
  } else {
    dataWithIds[newIndexToPlay].playState = {
      inPlay: true,
      toPlay: false,
      played: false,
    };
  }

  if (isMobile) {
    let itemDiv = document.getElementById(`CartItem-${newIndexToPlay + 1}`);
    itemDiv?.scrollIntoView({
      behavior: "smooth",
      block: "nearest",
      inline: "nearest",
    });
    let innerItemDiv = itemDiv.children[0].children[0];
    let textDiv = innerItemDiv.children[4];
    if (dataWithIds[newIndexToPlay].playState.played) {
      itemDiv.style.border = "none";
      textDiv.textContent = "Replay";
      textDiv.style.backgroundColor = "transparent";
    } else {
      itemDiv.style.borderTop = "2px solid #05FF00";
      itemDiv.style.borderBottom = "2px solid #05FF00";
      textDiv.style.backgroundColor = "#05FF00";
      textDiv.style.color = "black";
      textDiv.textContent = "In Play";
    }
  }

  if (!isMobile) {
    const { cartItemElement1, cartItemPrimaryDetail1 } =
      getStatusDiv(newIndexToPlay);
    if (dataWithIds[newIndexToPlay].playState.played) {
      cartItemElement1.style.border = "none";
      cartItemPrimaryDetail1.children[1].textContent = "Replay";
    } else {
      cartItemElement1.style.border = "3px solid #05FF00";
      cartItemPrimaryDetail1.children[1].textContent = "In Play";
      cartItemElement1?.scrollIntoView({
        behavior: "smooth", // Optional: for smooth scrolling
        block: "nearest", // Scrolls the div to the center of the view
        inline: "nearest", // Ensures the scroll only happens vertically, not horizontally
      });
    }
    const newSvgIcon = getPlayStateIcon(dataWithIds[newIndexToPlay].playState);

    const svgContainer =
      cartItemPrimaryDetail1.children[0].querySelector("img");

    if (svgContainer) {
      svgContainer.outerHTML = newSvgIcon;
    }
  }
};

const setPlayedOfPrevItem = async (index, x1, y1, x2, y2, nextPlayIndex) => {
  dataWithIds[index].playState = {
    inPlay: false,
    toPlay: false,
    played: true,
  };

  if (!isMobile) {
    const { cartItemElement1, cartItemPrimaryDetail1 } = getStatusDiv(index);
    cartItemElement1.style.border = "none";
    cartItemPrimaryDetail1.children[1].textContent = "Replay";

    const newSvgIcon = getPlayStateIcon(dataWithIds[index].playState);
    const svgContainer =
      cartItemPrimaryDetail1.children[0].querySelector("img");
    if (svgContainer) {
      svgContainer.outerHTML = newSvgIcon;
    }
  }

  if (isMobile) {
    let itemDiv = document.getElementById(`CartItem-${index + 1}`);
    let innerItemDiv = itemDiv.children[0].children[0];
    let textDiv = innerItemDiv.children[4];
    itemDiv.style.border = "none";
    textDiv.textContent = "Replay";
    textDiv.style.backgroundColor = "transparent";
    textDiv.style.color = "#1877F2";
  }

  try {
    playedStatusLoader = true;
    sendPlayedStatusToIframe();
    const response = await addAttemptData(
      index,
      { toPlay: false, inPlay: false, played: true },
      {
        x: x1,
        y: y1,
      },
      {
        x: x2,
        y: y2,
      }
    );

    const coordinateDiv = document.getElementById(`coordinates-${index + 1}`);
    coordinateDiv.style.color = "#04c000";
    // Check and create xDiv
    let xDiv = document.getElementById(`x-coordinate-${index + 1}`);
    if (!xDiv) {
      xDiv = document.createElement("div");
      xDiv.id = `x-coordinate-${index + 1}`;
      xDiv.style.marginRight = "5px";
    }
    xDiv.textContent = `X : ${x2 || x1}`;
    let yDiv = document.getElementById(`y-coordinate-${index + 1}`);
    if (!yDiv) {
      yDiv = document.createElement("div");
      yDiv.id = `y-coordinate-${index + 1}`;
    }
    yDiv.textContent = `Y : ${y2 || y1}`;

    coordinateDiv.appendChild(xDiv);
    coordinateDiv.appendChild(yDiv);
    currentItemIndex = nextPlayIndex;
    dataWithIds = response?.data?.attempts_array;
  } catch (error) {
  } finally {
    playedStatusLoader = false;
    sendPlayedStatusToIframe();
  }
};

window.onmessage = async function (e) {
  if (e.data.dimensionChanged && !isMobile) {
    imageDimensions = e.data.data;
    const drawer = document.getElementById("drawer-parent");
    const heading = document.getElementById("custom-drawer-header");
    const footer = document.getElementById("custom-drawer-footer");
    const itemsContainer = document.getElementById("custom-cart-drawer");
    drawer.style.height = `${e.data.data.height}px`;
    itemsContainer.style.height = `${
      e.data.data.height - heading.offsetHeight - footer.offsetHeight
    }px`;
  }
  if (e.data.dimensionChanged && isMobile && allowHeightChange) {
    const iframe = document.getElementById("testframe");
    const gameContainer = document.getElementById("game-container");
    const gameContainerHeight = gameContainer.offsetHeight;
    const drawer = document.getElementById("drawer-parent");
    availableHeight = gameContainerHeight - e.data.data.height;
    drawer.style.height = `${availableHeight - 130}px`;
    // iframe.style.height = `${iframe.offsetHeight + 60}px`
  }
  if (e.data.itemAdded) {
    dataWithIds = e.data.data?.attempts_array;
    await displayCartItems(e.data.data?.attempts_array);
    scrollToInplay(dataWithIds);
  }
  if (e.data.ticketPlayed === false) {
    const modal = document.getElementById("modal-coord-error");
    modal.style.display = "flex";
  }
  if (e.data.itemAdded === false) {
    const modal = document.getElementById("modal-coord-error");
    modal.style.display = "flex";
  }
  if (e.data.ticketPlayed === true) {
    const { index } = e.data;

    let itemInPlay = dataWithIds.findIndex((item) => item.playState.inPlay);
    if (index <= dataWithIds.length) {
      dataWithIds[currentItemIndex] = {
        ...dataWithIds[currentItemIndex],
        playState: {
          inPlay: false,
          toPlay: false,
          played: true,
        },
      };

      let newIndexToPlay = dataWithIds.findIndex(
        (item) => item.playState.toPlay
      );

      if (newIndexToPlay != -1) {
        await setPlayedOfPrevItem(
          currentItemIndex,
          e.data.coordinates.x,
          e.data.coordinates.y,
          e.data.image_coordinates?.imageX,
          e.data.image_coordinates?.imageY,
          newIndexToPlay
        );
        setInPlayOfCurrentItem(newIndexToPlay);
      } else {
        await setPlayedOfPrevItem(
          currentItemIndex,
          e.data.coordinates.x,
          e.data.coordinates.y,
          e.data.image_coordinates?.imageX,
          e.data.image_coordinates?.imageY,
          itemInPlay
        );
        setInPlayOfCurrentItem(itemInPlay);
      }

      if (newIndexToPlay != -1) {
      } else {
      }
    } else {
       const modal = document.getElementById('tickets-completed-modal');
       console.log("here",modal)
       modal.style.display = "flex";
      // try {
      //   if (!addItemLoader) {
      //     addItemLoader = true;
      //     sendAddCartItemStatusToIframe();
      //     toGetDataFromWebSocket = false;
      //     //update in shopify
      //     await updateCartItem(
      //       // dataWithIds[dataWithIds.length - 1].line,
      //       dataWithIds[dataWithIds.length - 1].quantity + 1,
      //       dataWithIds[dataWithIds.length - 1].variant_id,
      //       dataWithIds.length,
      //       true
      //     );

      //     // update in our backend
      //     const result = await addAttemptData(
      //       dataWithIds.length - 1,
      //       {
      //         toPlay: false,
      //         inPlay: false,
      //         played: true,
      //       },
      //       {
      //         x: e.data.coordinates.x,
      //         y: e.data.coordinates.y,
      //       },
      //       {
      //         x: e.data.image_coordinates?.imageX,
      //         y: e.data.image_coordinates?.imageY,
      //       }
      //     );
      //     addItemLoader = false;
      //     sendAddCartItemStatusToIframe();
      //     dataWithIds = result?.data?.attempts_array;
      //     displayCartItems(dataWithIds);
      //   }
      // } catch (error) {
      //   addItemLoader = false;
      //   sendAddCartItemStatusToIframe();
      // }
    }
  }
};

// Get all elements with the class 'cart-remove-button'
document.addEventListener('DOMContentLoaded', function() {
  cartremovegame();
});
function cartremovegame(){
const removeButtons = document.querySelectorAll('.cartremoveitem');
    removeButtons.forEach(button => {
      button.addEventListener('click', function() {
        const variantId = button.getAttribute('data-variant-id');
        const itemindex = button.getAttribute('data-itemindex');
        updateCartItem(0, variantId, itemindex, false);
      });
    });
}
document.addEventListener("DOMContentLoaded", function () {
  console.log( window.customerData);
    if ( window.customerData) {
        console.log("Customer is logged in:",  window.customerData);
        
        const url = `${BASE_URL}/webhooks/shopify-user`;
        // Send customer data via AJAX
        fetch(url, {
            method: "POST",
            headers: {
                "Content-Type": "application/json"
            },
            body: JSON.stringify( window.customerData)
        })
        .then(response => response.json())
        .then(data => console.log("Server Response:", data))
        .catch(error => console.error("Error:", error));
    } else {
        console.log("No customer is logged in.");
    }
});